import React from 'react';
import styles from '../styles/common.less';

const FilterHeader = ({ id, tabList, handleFilterTabClick, type, className, activeClassName }) => {
  return (
    <ul className={`${styles['opt-bar']} ${className}`} id={id}>
      {tabList.map(item => {
        const { label, value } = item;
        return (
          <li
            className={`${styles['opt-item']} ${
              type === value ? activeClassName || styles['active'] : ''
            }`}
            key={value}
            onClick={() => handleFilterTabClick(value)}
          >
            {label}
          </li>
        );
      })}
    </ul>
  );
};

export default FilterHeader;
